<template>
    <div class="warpper-voucher" v-if="campaigns.length > 0">
        <div class="voucher-title">{{ lbl.home.voucher }}</div>
        <div v-if="campaigns.length >= 10">
            <VoucherSlider10 :voucher="campaigns" @redeemVoucher="gotoCart('')"></VoucherSlider10>
        </div>
        <div v-else>
            <VoucherSlider :voucher="campaigns" @redeemVoucher="gotoCart('')"></VoucherSlider>
        </div>
    </div>
</template>

<script>
import Account from '@/helper/AccountHelper';
import AccountMixin from '@/mixin/AccountMixin';
import ModalMixin from '@/mixin/ModalMixin';
import ConfigManager from '@/config/ConfigManager';
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign';
import BzbsRedeem from '@/core/Redeem/service/BzbsRedeem.js';
import { RedeemConfigBuilder } from '@/core/Redeem/config/RedeemConfigBuilder.js';
import Locale from "@/helper/locale/Locale.js"
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel";
import VoucherSlider from "./Voucher/VoucherSlider.vue";
import VoucherSlider10 from "./Voucher/VoucherSlider-10.vue";
export default {
    name: "Voucher",
    mixins:[AccountMixin,ModalMixin],
    components: {
        VoucherSlider,
        VoucherSlider10
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            campaigns : [],
        }
    },
    created: function () {
        this.blobConfig = Account.getCacheBlob()
        this.redeemConfigBuilder = new RedeemConfigBuilder();
        this.initialCampaign()
        this.getList()
    },
    methods: {
        initialCampaign: function () {
            this.listConfig = {};
            this.filterConfig = {};

            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(this.blobConfig.voucher_list_config)
                .setSeeMore(false);

                this.listConfig = listConfig.create();

            var filterConfig = new CampaignListFilterConfigBuilder();
            this.filterConfig = filterConfig.create();

        },
        getList: function() {
            if (!this.listConfig.strConfigList) return;

            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaign(strBzbsToken, this.listConfig,  this.filterConfig)
                .subscribe((campaigns) => {
                    for (var campaign of campaigns) {
                        this.campaigns.push(campaign);
                    }

                    this.isHaveItem = this.campaigns.length > 0
                        ? true
                        : false;
                    this.isLoaded = true;
                }, (error) => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    console.log(error);
                });
        },
        redeemVoucher: function(voucher) {
            console.log(voucher)
            var token = Account.getToken();
            var params = this.redeemConfigBuilder.getRedeemParams();
            BzbsRedeem.apiRedeemCampaign(token, voucher.id, params, 1)
                .subscribe((res) => {
                    console.log(res)
                }, (err) => {
                    console.log(err)
                });
        },
        shoppingCartUrl: function(path) {
            if (this.cartConfig.shoppingcart_url) {
                let mainUrl = this.cartConfig.shoppingcart_url
                if(path){
                    mainUrl = this.cartConfig.shoppingcart_url + path
                }
                let token = Account.getToken();
                let localeCode = Locale.getLocaleCode();
                let returnUrl = this.query.returnUrl;
                let appId = ConfigManager.getAppId()
                let api = this.cartConfig.api_prefix
                let brand = 'b2bmarketplace'
                let strUrl = mainUrl
                    + '?return_url=' + returnUrl
                    + '&token=' + token
                    + '&locale=' + localeCode
                    + '&theme=ecommerce_brand_a'
                    + '&multilang=true'
                    + '&appid=' + appId
                    + '&api=' + api
                    + '&brand=' + brand;

                return strUrl
            }
        },
        gotoCart: function(path) {
            if (this.isLogin) {
                this.blobConfig = Account.getCacheBlob();
                this.cartConfig = Account.getCacheCart();
                this.query = Account.getCacheQuery();

                const cartUrl = new URL(this.shoppingCartUrl(path));
                if (this.blobConfig.shopping_cart_redirect_b2b_marketplace) {
                    cartUrl.searchParams.set('return_url', encodeURIComponent(window.location.href));
                }
                window.location.replace(cartUrl.toString());
            } else {
                this.$emit('notLogin');
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";

.warpper-voucher {
    padding: 20px 0;
    .voucher-title {
        text-align: center;
        font-size: $px16;
        color: $a-black-333333;
        padding-bottom: 15px;
    }
}
</style>
